import React from 'react';
import Helmet from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { Button } from '@material-ui/core';
import { PageTemplate, PageTemplateCardOver, PageTemplateHeader, SearchBox } from '@sierralabs/core-ui';
import { useSiteContext } from '../SiteContext';
import ReportListTable from './tables/ReportListTable';
export const ReportListPage = () => {
    const history = useHistory();
    const { editorPath } = useSiteContext();
    const [search, setSearch] = useQueryParam('search', withDefault(StringParam, ''));
    return (React.createElement(PageTemplate, null,
        React.createElement(Helmet, { title: 'Reports' }),
        React.createElement(PageTemplateHeader, null,
            React.createElement("h2", null, "Reports"),
            React.createElement(SearchBox, { value: search, onSearch: value => setSearch(value) }),
            React.createElement(Button, { color: 'primary', variant: 'contained', onClick: () => history.push(`${editorPath}reports/new`) }, "New Report")),
        React.createElement(PageTemplateCardOver, null,
            React.createElement(ReportListTable, { search: search || undefined }))));
};
export default ReportListPage;
//# sourceMappingURL=ReportListPage.js.map